module.exports = __webpack_public_path__ + "static/media/vmove-logo-mobile.97603012.svg";